import {useDispatch, useSelector} from 'react-redux'
import _ from 'lodash'
import {SetCompanySuspensionStatusRequest, BooleanApiData} from '../../../api/data-contracts'
import {Api_ServiceProvider_SetCompanySuspensionStatus} from '../../../apiClient/apiClient'
import {CompanySuspensionStatusEnum} from '../../../apiClient/enums'
import {setIsLoading, postRequestAsync} from '../../../redux/commonSlice'
import AreYouSurePopup from '../../common/popup/AreYouSurePopup'
import {getAdminState} from '../../../redux/adminSlice'
function CompanySetSuspensionStatus(props: {load: () => void}) {
  const dispatch = useDispatch()
  const adminState = useSelector(getAdminState)

  async function setStatus(statusId: number) {
    dispatch(setIsLoading(true))

    const values: SetCompanySuspensionStatusRequest = {
      suspensionStatusId: statusId,
      companyId: adminState.company?.company?.guid ?? '',
    }
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_ServiceProvider_SetCompanySuspensionStatus,
        body: values,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        props.load()
      })
  }

  return (
    <div className='d-flex'>
      {adminState?.company?.company?.suspensionStatusId ==
        CompanySuspensionStatusEnum.Mali_Müşavir_Değiştirmek_İstiyor && (
        <>
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-danger me-3'>
                <span className='indicator-label'>Mali Müşavir Değişim İptal</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(0)}
          />
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-warning me-3'>
                <span className='indicator-label'>Mali Müşavir Değişim Başlat</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(CompanySuspensionStatusEnum.Mali_Müşavir_Değişim_Başladı)}
          />
        </>
      )}

      {adminState?.company?.company?.suspensionStatusId ==
        CompanySuspensionStatusEnum.Mali_Müşavir_Değişim_Başladı && (
        <>
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-danger me-3'>
                <span className='indicator-label'>Mali Müşavir Değişim İptal</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(0)}
          />
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-warning me-3'>
                <span className='indicator-label'>Mali Müşavir Değişim Tamamlandı</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(CompanySuspensionStatusEnum.Mali_Müşavir_Değiştirdi)}
          />
        </>
      )}

      {adminState?.company?.company?.suspensionStatusId ==
        CompanySuspensionStatusEnum.Şirketi_Kapatmak_İstiyor___Tasfiye_Başladı && (
        <>
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-danger me-3'>
                <span className='indicator-label'>Tasfiye İptal Et</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(0)}
          />
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-warning me-3'>
                <span className='indicator-label'>Tasfiye Başladı</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(CompanySuspensionStatusEnum.Tasfiye_Başladı)}
          />
        </>
      )}

      {adminState?.company?.company?.suspensionStatusId ==
        CompanySuspensionStatusEnum.Tasfiye_Başladı && (
        <>
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-danger me-3'>
                <span className='indicator-label'>Tasfiye İptal Et</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() => setStatus(0)}
          />
          <AreYouSurePopup
            modalOpener={
              <button type='submit' className='btn btn-lg btn-warning me-3'>
                <span className='indicator-label'>Tasfiye Tamamlandı</span>
              </button>
            }
            message='FESIH_DURUMUNU_DEGISTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
            onClick={() =>
              setStatus(CompanySuspensionStatusEnum.Şirket_Kapandı___Tasfiye_Sonuçlandı)
            }
          />
        </>
      )}
    </div>
  )
}

export default CompanySetSuspensionStatus
